import React, { useState, useEffect, useRef } from "react";
import { IoChevronDownOutline } from "react-icons/io5";
import "./ServiceTabs.scss";

const ServiceTabs = ({ activeTab, setActiveTab }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const tabs = [
    { id: "products", label: "Products" },
    { id: "priorityDMs", label: "Priority DMs" },
    { id: "meetings", label: "Meetings" },
    { id: "events", label: "Events" },
    { id: "webinars", label: "Webinars" },
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    setIsDropdownOpen(false);
  };

  const getActiveTabLabel = () => {
    return tabs.find(tab => tab.id === activeTab)?.label || "Select Tab";
  };

  const toggleDropdown = (e) => {
    e.stopPropagation();
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <div className="service-tabs">
      {/* Mobile Dropdown */}
      <div className="mobile-dropdown" ref={dropdownRef}>
        <button 
          className="dropdown-toggle-mobile"
          onClick={toggleDropdown}
        >
          <span>{getActiveTabLabel()}</span>
          <IoChevronDownOutline className={`icon ${isDropdownOpen ? 'open' : ''}`} />
        </button>
        {isDropdownOpen && (
          <div className="dropdown-menu-mobile">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                className={`dropdown-item ${activeTab === tab.id ? 'active' : ''}`}
                onClick={() => handleTabClick(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </div>
        )}
      </div>

      {/* Desktop Tabs */}
      <div className="desktop-tabs">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`tab ${activeTab === tab.id ? "active" : ""}`}
            onClick={() => handleTabClick(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ServiceTabs; 